export const connection = {
	'connection-alive': "Votre connexion internet semble s'être rétablie. Cet affreux cauchemard est terminé.",
	'no-connection': "ZzzzZzzz, votre connexion internet semble s'être endormie. Il est possible que certaines données ne soient plus accessibles."
}
